import * as React from "react";
import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { useEffect } from "react";
import mangaInfo from "../model/MangaInfo";
import styled from "styled-components";
import {
	eCMainImg,
	logoEComicSP, logoEComicSP_K, logoEComicSR, logoEComicSR_K,
	plusComic, srComic
} from "../model/DataConst";
import {
	device, ECSP_URL, ECSR_URL,
	MAX_WIDTH_PLANE,
	MAX_WIDTH_PLANE_STR, WHATISMOIRE_URL,
} from "../model/Const";
import Footer from "./Footer";
import { MangaHeaderParentDiv } from "./parts/MangaView";
import { IUADevice, userAgentInfo } from "../model/UserAgentInfo";
import { OrientationContext } from "../provider/OrientationProvider";

const PanelDiv = styled.div`
	height: 100%;
	width: 100%;
	position: relative;
	text-align: center;
`;

const AskHeaderP = styled.p`
	padding: 0 0 20px 0;
	position: relative;
`;

const MessageP = styled.p`
	text-align: center;
	font-size: 1rem;
    @media ${device.mobileS} {
		font-size: 0.8rem;
    }
    @media ${device.mobileM} {
		font-size: 0.8rem;
    }
    @media ${device.mobileL} {
		font-size: 0.8rem;
    }
`;

const SummaryImg = styled.img`
	margin-top: 10%;
`;

const SummaryP = styled.p`
	text-align: center;
	margin-block-start: .1em;
    margin-block-end: .1em;
	font-size: 1rem;
    @media ${device.mobileS} {
		font-size: 0.8rem;
    }
    @media ${device.mobileM} {
		font-size: 0.8rem;
    }
    @media ${device.mobileL} {
		font-size: 0.8rem;
    }
`;

const ButtonLabelPercentDiv = styled.div`
	background-color: mediumaquamarine;
	color: white;
	font-weight: bold;
	padding: 10px;
	font-family: nicomoji;
	user-select: none;
	text-align:center;
`;
const LinkButtonAreaParentDiv = styled.div`
	height: 10%;
	position: relative;
	background-color: white;
`;

const LinkButtonAreaDiv = styled.div`
	width: 100%;
	height: 100%;
`;

const LinkButtonDiv = styled.div`
	width: 100%;
	height: 100px;
	position: relative;
	overflow: hidden;
`;

export const MangaHeaderTitleH1 = styled.h1`
	font-family: nicomoji;
	text-align: center;
	width: 100%;
	opacity: 1;
`;
const NoAnimationSampleLinkButton = React.memo( ( props: {
	toURL: string,
	text: string,
	maxStyle?: CSSProperties
} ) => {
	const anchorStyle: CSSProperties = {
		right: "5%",
		position: "absolute",
		textDecoration: "none"
	};

	return <LinkButtonAreaParentDiv>
		<LinkButtonAreaDiv
			style={{
				...props.maxStyle,
				backgroundColor: "white"
			}}
		>
			<LinkButtonDiv className={"catch"}>
				<a href={props.toURL}
				   style={anchorStyle}
				   target="_blank"
				   rel="noopener noreferrer"
				>
					<ButtonLabelPercentDiv>
						{props.text}
					</ButtonLabelPercentDiv>
				</a>
			</LinkButtonDiv>
		</LinkButtonAreaDiv>
	</LinkButtonAreaParentDiv>;
} );

const MangaHeaderSpan = styled.p`
	font-size: 130%;
	margin-top: 5%;
`;

const MangaHeaderImg = styled.img`
	margin: 0%;
`;

const BorderDiv = styled.div`
	  margin-top: 5vh;
	  height: 4px;
	  width: 98vw;
	  background-color: rgb(89, 87, 87);
`;

export const NoAnimationMangaHeader = (
	src: string,
	alt: string,
	message: string,
	style: CSSProperties
) => {
	return <MangaHeaderParentDiv>
		<BorderDiv/>
		<MangaHeaderTitleH1
			className={"visible"}
		>
			<MangaHeaderSpan>{message}</MangaHeaderSpan>
			<MangaHeaderImg
				style={style}
				src={src}
				alt={alt}
			/>
		</MangaHeaderTitleH1>
	</MangaHeaderParentDiv>;
};

export const Plane = ( props: { alertMessage: string } ) => {

	const imgParentRef = React.useRef<HTMLDivElement>( null );

	const [isShow, setShow] = React.useState( false );

	useEffect( () => {
		mangaInfo.setWaitMainFunc( () => {
			setShow( true );
		} );
	}, [] );

	// useContext
	const context = React.useContext( OrientationContext );

	// 最大幅を設定するスタイル（PCの場合のみ設定）
	const maxWidthStyle = React.useMemo( () => {
		// 幅が最大幅より大きく、PCだったら最大幅を指定
		if ( window.innerWidth > MAX_WIDTH_PLANE && userAgentInfo.device === IUADevice.pc ) {
			return {
				max: {
					maxWidth: MAX_WIDTH_PLANE_STR,
					margin: "auto"
				} as CSSProperties,
				ecspMax: {
					maxWidth: "900px",
				},
				ecsrMax: {
					maxWidth: "560px",
				}
			}
		}

		return {
			parentDiv: undefined,
			askHeader: undefined,
			ecspMax: {
				maxWidth: "90%"
			},
			ecsrMax: {
				maxWidth: "56%"
			}
		};
	}, [context.resize] );

	const imgStyle = React.useMemo( () => {
		const style: CSSProperties = {};
		style.width = "100%";
		style.height = "100%";
		return style;
	}, [isShow] );

	if ( !isShow ) {
		return <div
			style={{
				height: "100%",
				width: "100%",
				background: "linear-gradient(0deg, rgb(223, 0, 58), #ffb03c)",
				color: "white"
			}}
		>
			Now Loading...
		</div>;
	}

	return (
		<div style={{ overflow: "hidden" }}>
			{/*	MainVisual */}
			<section>
				<PanelDiv>
					<div ref={imgParentRef}
						 style={{
							 ...imgStyle
						 }}>
						<img
							src={eCMainImg}
							alt={"Key Visual"}
							style={{
								...imgStyle,
								objectFit: "contain"
							}}
						/>
					</div>
				</PanelDiv>
			</section>

			{/*Ask*/}

			<section>
				<div style={{
					width: "100%",
					textAlign: "center",
					backgroundColor: "white",
					position: "relative"
				}}>
					<h1 style={{
						width: "100%",
						textAlign: "center"
					}}>
						<AskHeaderP style={{
							...maxWidthStyle.max,
							fontFamily: "nicomoji",
							fontWeight: "normal"
						}}>本当にキレイな電子コミックってみたことありますか？</AskHeaderP>
					</h1>
				</div>

				{/*Overview*/}
				<div
					style={{
						width: "100%",
						textAlign: "center",
						backgroundColor: "white"
					}}
					className={"mincho"}
				>
					<div style={{
						position: "relative",
						width: "100%",
						height: "100%",
						scrollSnapAlign: "start",
						backgroundColor: "white"
					}}>
						<div style={{
							position: "relative",
							...maxWidthStyle.max,
						}}>
							<MessageP>まんがにこだわる共同印刷ならではの、</MessageP>
							<MessageP>高品質な電子コミック制作ソリューションが</MessageP>
							<MessageP>『eComicシリーズ』です。</MessageP>
							<MessageP>モアレを抑制しつつ高品質のまんが画像を生成する『eComicScreen+™️』</MessageP>
							<MessageP>過去に制作したまんが画像を超解像技術でデジタルリマスターする『eComicSR™️』</MessageP>
							<MessageP>2つの技術でこれまでの電子コミックの常識を変えます。</MessageP>
						</div>
					</div>
				</div>
				<NoAnimationSampleLinkButton
					toURL={WHATISMOIRE_URL}
					text={"モアレとは"}
					maxStyle={maxWidthStyle.max}
				/>
			</section>

			{/*	ECSVerticalScroll*/}
			<section>
				{NoAnimationMangaHeader( logoEComicSP, "eComicScreen+", "大きな画像をキレイに作成することに特化した", {
					...maxWidthStyle.ecspMax,
					maxHeight: "10%",
					margin: "20px",
				} )}
				<div style={{
					...maxWidthStyle.max,
					width: "100%",
					height: "100%",
					position: "relative"
				}} className={"ecsp"}>
					<img src={plusComic} alt={"eComicScreen+紹介コミック"} style={{
						width: "100%",
						height: "100%",
						objectFit: "contain"
					}}/>
				</div>
				<NoAnimationSampleLinkButton
					toURL={ECSP_URL}
					text={"サンプルはこちら"}
					maxStyle={maxWidthStyle.max}
				/>
			</section>

			{/*	ECSRVerticalScroll*/}
			<section>
				{NoAnimationMangaHeader( logoEComicSR, "eComicSR", "小さな画像をキレイに拡大することに特化した", {
					...maxWidthStyle.ecsrMax,
					maxHeight: "10%",
					margin: "20px"
				} )}
				<div style={{
					...maxWidthStyle.max,
					width: "100%",
					height: "100%",
					position: "relative"
				}} className={"ecsr"}>
					<img src={srComic} alt={"eComicSR紹介コミック"} style={{
						width: "100%",
						height: "100%",
						objectFit: "contain"
					}}/>
				</div>
				<NoAnimationSampleLinkButton
					toURL={ECSR_URL}
					text={"サンプルはこちら"}
					maxStyle={maxWidthStyle.max}
				/>
			</section>

			{/*	Summary*/}
			<section>
				<div
					style={{
						position: "relative",
						overflow: "hidden",
						backgroundColor: "white",
						padding: "5% 0 10% 0",
						minHeight: "80%",
						textAlign: "center"
					}}
					className={"mincho"}
				>
					<SummaryImg
						style={maxWidthStyle.ecspMax}
						src={logoEComicSP_K}
						alt="eComicScreen+"/>

					<SummaryP>電子コミックで発生するモアレを効果的に抑制し、高解像度画像を作成。</SummaryP>
					<SummaryP>モアレに悩まされることなく、シャープでキレイな線やセリフを実現。</SummaryP>
					<SummaryP>新刊電子コミックに最適</SummaryP>

					<SummaryImg
						style={maxWidthStyle.ecsrMax}
						src={logoEComicSR_K}
						alt="eComicSR"/>

					<SummaryP>これまで制作した電子コミックのデータをベースとした超解像技術。</SummaryP>
					<SummaryP>電子コミックを再制作することなく高解像度化。</SummaryP>
					<SummaryP>既刊電子コミックに最適</SummaryP>

					<SummaryP style={{ marginTop: "8%" }}>高解像度化するスマートフォンやタブレット。</SummaryP>
					<SummaryP>eComicシリーズを活用することで時代に最適化。</SummaryP>
					<SummaryP>電子コミックはより価値のあるものへと生まれ変わります。</SummaryP>
				</div>
			</section>

			{/*フッター*/}
			<Footer style={maxWidthStyle.max}/>

			<div style={{
				color: "red",
				fontWeight: "bold",
				position: "fixed",
				top: 0,
				margin: "0 20px",
				fontSize: "0.8em"
			}}>
				{props.alertMessage}
			</div>
		</div>
	);
};

export default Plane;